import { store } from './store';

import { TranslationsData } from 'src/reducers/partner/types';

import * as log from 'Utilities/log';

interface Urls {
  lslApi: string;
}

/** Reference used to store urls */
export const urls: Urls = {
  lslApi: '',
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = <T>(config: Partial<Urls>) => {
  const { lslApi } = config;

  Object.assign(urls, {
    lslApi,
  });
};

export const convertMgToMmol = (value: string | number) => Number((Number(value) / 18).toFixed(1));
export const convertMmolToMg = (value: string | number) => Number((Number(value) * 18).toFixed(0));

/**
 * Will get the `key` from the `trans` data from the partner data. returns empty string if one isn't found
 * using the `langFallBack` from config
 * @param trans The partner configuration for tanslations
 */
export const getTranslation = (trans: TranslationsData, key: string): string => {
  if (trans === null) {
    return '';
  }

  const lang = store ? store.getState().user.uiLanguage || 'en-GB' : 'en-GB';
  // This should be the configurable list of supported languages
  const { langFallBack = { default: ['en-US'] } } = store ? store.getState().config : {};
  let fallbacks = langFallBack[lang] || [];
  const langs = lang ? [lang] : [];

  // Add 2 char fallbacks after 5 char fallbacks
  fallbacks = fallbacks.concat(langFallBack[lang.substr(0, 2)] || []);

  const fullList = [...new Set([...langs, ...fallbacks, ...langFallBack['default'], 'default'])];

  for (const l of fullList) {
    if (trans.languages[l]) {
      if (trans.languages[l][key]) {
        return trans.languages[l][key];
      }
    }
  }

  return '';
};

// Get Region of the country belongs to. If not found, just return the country itself
export const getRegionForCountry = (country: string): string => {
  const { regions = {} } = store.getState().config;

  const possibleRegions = Object.keys(regions);

  for (let i = 0; i < possibleRegions.length; i++) {
    const result = regions[possibleRegions[i]].countries.find((x) => x === country);

    if (result) {
      return possibleRegions[i];
    }
  }

  log.error(
    `getRegionForCountry: region for country ${country} not found. please add it to config!`
  );

  return country;
};
